import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalOrderQuoteCardNode } from '@app/services/api/api.types';

@Component({
  selector: 'prices-tooltip',
  templateUrl: './prices-tooltip.component.html',
  styleUrls: ['./prices-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricesTooltipComponent {
  @Input() option: PortalOrderQuoteCardNode;
}
